import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  reloadTariffs(e) {
    e.preventDefault();

    let url = this.data.get("url");

    fetch(this.data.get("url"))
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".account-tariffs-container").innerHTML = html;
      })
      .catch(err => {
        showCardLoadError(this.element, err);
      });
  }
}
